import { t } from "i18next";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa";
// import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import { Link as ScrollLink } from "react-scroll";
const BannerTwo = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();

  
  return (
    <>
      <div
        className="banner-area bg-relative banner-area-2 bg-cover"
        style={{ backgroundImage: 'url("./assets/img/bg/8.png")' }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="banner-inner pe-xl-5">
                <h6
                  className="subtitle"
                  data-aos="fade-right"
                  data-aos-delay="100"
                  data-aos-duration="1500"
                >
                  {t("banner.subtitle")}
                </h6>

                <h2
                  className="title"
                  data-aos="fade-right"
                  data-aos-delay="200"
                  data-aos-duration="1500"
                >
                  <Trans i18nKey="banner.title">
                    Agissons Contre <span>l'Harcèlement</span> Tous Ensemble
                  </Trans>
                </h2>

                <p
                  className="content"
                  data-aos="fade-right"
                  data-aos-delay="250"
                  data-aos-duration="1500"
                >
                  {t("banner.paragraph")}
                </p>

                <ScrollLink
                  to="contact-section"
                  smooth={true}
                  duration={1000}
                  className="btn btn-base"
                  data-aos="fade-right"
                  data-aos-delay="300"
                  data-aos-duration="1500"
                >
                  {t("banner.button")} <FaPlus />
                </ScrollLink>

                <div
                  className="d-inline-block align-self-center"
                  data-aos="fade-right"
                  data-aos-delay="350"
                  data-aos-duration="1500"
                >
                  <span
                    onClick={() => setOpen(true)}
                    className="video-play-btn-hover"
                  >
                    <img src="assets/img/video.svg" alt="img" />
                    <h6 className="d-inline-block">
                      {t("banner.video_title")}
                    </h6>
                  </span>
                </div>

                <ModalVideo
                  channel="youtube"
                  autoplay
                  isOpen={isOpen}
                  videoId="KPVMFvNjK1A"
                  onClose={() => setOpen(false)}
                />
              </div>
            </div>
            <div
              className="col-lg-6 col-md-9 "
              data-aos="fade-left"
              data-aos-delay="100"
              data-aos-duration="1500"
            >
              <div className="banner-thumb-2 mt-4 mt-lg-0">
                <img
                  className="banner-animate-img banner-animate-img-4"
                  src="assets/img/banner-2/8.1.png"
                  alt="img"
                />
                <div className="main-img-wrap">
                  <img
                    className="banner-animate-img banner-animate-img-1 left_image_bounce"
                    src="assets/img/banner-2/4.png"
                    alt="img"
                  />
                  <img
                    className="banner-animate-img banner-animate-img-2 left_image_bounce"
                    src="assets/img/banner-2/5.png"
                    alt="img"
                  />
                  <img
                    className="banner-animate-img banner-animate-img-3 top_image_bounce"
                    style={{ top: "50%" }}
                    src="assets/img/banner-2/phone.png"
                    alt="img"
                  />
                  <img
                    className="main-img"
                    src="assets/img/banner-2/women-chuldren3.png"
                    alt="img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================== BannerTwo End ==================*/}
    </>
  );
};

export default BannerTwo;
